<template>
  <div>
    <div class="row" v-if="typeof(items.length) === 'undefined'">
        <div class="col-md-12 p-2 text-center">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
    </div>
    <div class="row" v-else>
      <div class="col-12">
          <h2 class="section__title  mb-5">HDD Files</h2>
      </div>
      <div class="col-12">
         <flash message="" class="mb-4 pl-4"></flash>
      </div>
       <div class="col-12"> 

        <div class="card border-0">
          <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                  <nav aria-label="breadcrumb">
                    <ol class="breadcrumb" >   
                      <li class="breadcrumb-item" v-bind:class="{'active' : index == breadcrumbs.length - 1}" v-for="(breadcrumb, index) in breadcrumbs">
                        <a href="/hdd" v-if="index == 0" >HDD</a>
                        <span v-if="index > 0">
                          <a v-if="index == breadcrumbs.length - 1">{{(breadcrumb.name == 'My Files' ? 'HDD' : breadcrumb.name)}}</a>
                          <a v-else :href="'/hdd?folder_id='+breadcrumb.id">{{(breadcrumb.name == 'My Files' ? 'HDD' : breadcrumb.name)}}</a>
                        </span>
                      </li>
                    </ol>
                  </nav>
                </div>
                <div class="col-md-12 text-center p-5" v-if="!items.length">
                    <svg class="icon icon-folder-empty pb-3"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-folder-empty"></use></svg>
                    <h3 class="mb-3"><b>Empty folder</b></h3>
                    <p class="text-muted">Looks like this folder is empty.</p>
                    <button class="btn btn-outline-secondary mt-3" v-if="current_folder.name != 'root'  && items_selected.length == 0"  @click="deleteItemModal(null,folder_id,(current_folder.name == 'root' ? 'Files' : current_folder.name),'folder')">Delete Folder</button>
                </div>
                <div class="col-md-12 transfer-list"  v-else-if="items.length">
                  <div class="d-flex justify-content-between mb-2 select_all">
                    <div class="align-self-center">
                      <div class="control-checkbox mt-4">
                        <label class="mb-0">
                          <input type="checkbox" @click="selectAll" v-model="allSelected"><span class="control-checkbox__checkbox"><i></i></span><span class="control-checkbox__text ml-4">Select All</span>
                        </label>
                      </div>
                    </div>
                    <div class="align-self-center text-center">
                      <span class="d-block d-sm-none">
                        <button class="btn btn-link" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"><i class="fas fa-ellipsis-v text-dark"></i></button>
                        <ul class="dropdown-menu">
                          <li>
                            <a href="javascript:void(0);" class="dropdown-item" @click="exportAll($event)"><i class="fas fa-file-export fa-fw"></i> Export All Links</a>
                          </li>
                          <li v-show="items_selected.length > 0">
                            <a href="javascript:void(0);" class="dropdown-item" @click="exportSelected($event)"><i class="fas fa-file-export fa-fw"></i> Export Selected</a>
                          </li>
                          <li v-show="items_selected.length > 0">
                            <a href="javascript:void(0);" class="dropdown-item" @click="zipMultipleItem($event)"><i class="fas fa-file-archive fa-fw"></i> Zip Selected</a>
                          </li>
                          <li v-show="items_selected.length > 0">
                            <a href="javascript:void(0);" data-toggle="modal" data-target="#deleteItemsModal" class="dropdown-item"><i class="fas fa-times-circle fa-fw"></i> Delete Selected</a>
                          </li>
                        </ul>
                      </span>
                      <span class="d-none d-sm-block">
                        <button class="btn --theme-primary --style-xsmall"  @click="exportAll($event)"><i class="fas fa-file-export"></i> Export All Links </button>
                        <span v-if="items_selected.length > 0">
                          <button class="btn --theme-primary --style-xsmall"  @click="exportSelected($event)"><i class="fas fa-file-export"></i> Export Selected </button>
                          <button class="btn --theme-primary --style-xsmall" v-show="items_selected.length > 0" @click="zipMultipleItem($event)"><i class="fas fa-file-archive"></i> Zip Selected </button>
                          <button class="btn --theme-primary --style-xsmall"  v-show="items_selected.length > 0" data-toggle="modal" data-target="#deleteItemsModal"><i class="fas fa-times-circle"></i> Delete Selected </button>
                        </span>
                        <span v-else>
                          <button class="btn btn-secondary --style-xsmall" disabled><i class="fas fa-file-export"></i> Export Selected </button>
                          <button class="btn btn-secondary --style-xsmall" disabled><i class="fas fa-file-archive"></i> Zip Selected </button>
                          <button class="btn btn-secondary --style-xsmall" disabled><i class="fas fa-times-circle"></i> Delete Selected </button>
                        </span>
                      </span>
                    </div>
                  </div>
                  <div class="d-flex flex-row transfer_list transfer-content" v-for="(item, index) in filteredItems">
                    <div class="justify-content-center align-self-center">
                      <div class="control-checkbox mr-3">
                        <label  class="mb-0">
                          <input type="checkbox" v-model="items_selected" @click="select" :value="item"><span class="control-checkbox__checkbox"><i></i></span>
                        </label>
                      </div>
                    </div>
                    <div class="d-flex flex-grow-0 justify-content-center align-self-center files-icon" >
                      <i class="icon icon-type-txt"  v-if="item.name.includes('.txt')"></i> 
                      <i class="icon icon-type-pdf"  v-else-if="item.name.includes('.pdf')"></i> 
                      <i class="icon icon-type-mp3"  v-else-if="item.name.includes('.mp3')"></i> 
                      <i class="icon icon-type-flv"  v-else-if="item.name.includes('.flv')"></i> 
                      <i class="icon icon-type-rar"  v-else-if="item.name.includes('.rar')"></i> 
                      <i class="icon icon-type-mp4"  v-else-if="item.name.includes('.mp4')"></i> 
                      <i class="icon icon-mkv"  v-else-if="item.name.includes('.mkv')"></i> 
                      <i class="icon icon-type-avi"  v-else-if="item.name.includes('.avi')"></i> 
                      <i class="icon icon-type-html"  v-else-if="item.name.includes('.html')"></i> 
                      <i class="icon icon-type-exe"  v-else-if="item.name.includes('.exe')"></i> 
                      <i class="icon icon-type-iso"  v-else-if="item.name.includes('.iso')"></i>
                      <i class="icon icon-type-torrent"  v-else-if="item.name.includes('.torrent')"></i>  
                      <i class="icon icon-type-file"  v-else-if="item.type == 'file'"></i>  
                      <i class="icon icon-folder" style="font-size: 30px;padding: 3px;" v-else></i>
                    </div>
                    <div class="name px-1 d-flex flex-grow-1 text-white justify-content-start align-self-center">
                      <div class="d-flex flex-column w-100">
                          <a v-if="item.type == 'file'" :href="'/hdd?id='+item.id" class="transfer-name">{{ item.name }}</a>
                          <a v-else href="javascript:void(0);" class="transfer-name" @click="diveUpToFolder(item.id)">{{ item.name }}</a>
                          <small class="text-muted text-sm" v-show="item.type == 'file'">{{item.size | humanFileSize }}</small>
                      </div>
                    </div>
                    <div class="action d-flex flex-grow-0 text-white justify-content-center align-self-center">
                      <span class="d-block d-sm-none">
                        <button class="btn btn-link" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"><i class="fas fa-ellipsis-v text-dark"></i></button>
                        <ul class="dropdown-menu">
                          <li v-show="item.type == 'file'">
                            <a :href="item.link" class="dropdown-item">Download File</a>
                          </li>
                          <li>
                            <a href="javascript:void(0);" class="dropdown-item"  @click="deleteItemModal(index,item.id,item.name,item.type)">Delete</a>
                          </li>
                        </ul>
                      </span>
                      <span class="d-none d-sm-block">
                        
                        <a :href="item.link"  class="btn btn-outline-secondary mx-1" v-show="item.type == 'file'">Download File</a> 
                        <button class="btn transfer-remove"  @click="deleteItemModal(index,item.id,item.name,item.type)"><i class="fas fa-times-circle text-secondary"></i></button>
                      </span>
                    </div>
                    
                  </div>
                </div>
            </div>
          </div>
        </div>   
                
        </div>
    </div>
    <div class="modal fade" id="exportLinksModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
       <div class="modal-dialog" role="document">
          <div class="modal-content">
             <div class="modal-header">Export Links</div>
             <div class="modal-body text-center">
                <div class="row pmcard-row">
                  <div class="col-md-12" v-if="export_links.length == 0 && this.premium">No file selected!</div>
                  <div class="col-md-12" v-if="!this.premium">
                    <div class="text-center">
                      <div role="alert" class="alert alert-danger">
                        Get a membership to download, stream, or generate links.
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12" v-else>
                    <textarea rows="5" :value="export_links.join('\n')" class="directlinks form-control" style="white-space: pre;"></textarea>
                  </div>
                </div>
             </div>
             <div class="modal-footer">
              <button type="button" class="btn btn-secondary --style-xsmall" data-dismiss="modal">Close</button>
             </div>
          </div>
       </div>
    </div>
    <div class="modal fade" id="zipModal" tabindex="-1" role="dialog" aria-labelledby="zipModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="createFolderModalLabel">Zip Download</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="col-md-12 p-2 text-center" v-if="!zip_data.finish">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            <div v-else class="text-center">
                <div class="alert alert-danger" role="alert" v-if="zip_data.error != null">
                  {{zip_data.error}}
                </div>
                <div v-else>
                    <p><a :href="zip_data.link" class="btn btn-success --style-xsmall">Click here to download</a></p>
                </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary --style-xsmall" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-labelledby="deleteModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="deleteModalLabel">Confirmation</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
             <p v-if="selected_item.type == 'folder'" class="text-break-all">Do you really want to delete the folder <b>{{ selected_item.name }}</b> including all its contents?</p>
             <p v-else  class="text-break-all">Do you really want to delete the file <b>{{ selected_item.name }}</b>?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary --style-xsmall" data-dismiss="modal">No</button>
            <button type="button" class="btn --theme-primary --style-xsmall" id="delete_item_btn" @click="deleteItem">Yes</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="deleteItemsModal" tabindex="-1" role="dialog" aria-labelledby="deleteModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="deleteModalLabel">Confirmation</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
             <p v-if="items_selected.length > 1">Do you really want to delete these items?</p>
             <p v-else>Do you really want to delete these item?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary --style-xsmall" data-dismiss="modal">No</button>
            <button type="button" class="btn --theme-primary --style-xsmall" id="delete_item_btn" @click="deleteItems">Yes</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>

  import dayjs from 'dayjs';
  import relativeTime from 'dayjs/plugin/relativeTime';
  import customParseFormat from 'dayjs/plugin/customParseFormat';

  export default {
      props: ['message','premium'],
      data() {
          return {
            folder_id: this.getParameterFromUrl('folder_id'),
            current_folder: { name: 'root', parent_id : null},
            breadcrumbs: {},
            items: {},
            selected_item: {},
            export_links: [],
            zip_data: { link: null, finish: false, error: null },
            selected: [],
            allSelected: false,
            items_selected: [],
          }
      },
      computed: {
          filteredItems() {
            let tempItems = this.items
                  
                tempItems = tempItems.sort((a, b) => {
                    if (this.sortBy == 'name') {
                        let fa = a.name.toLowerCase(), fb = b.name.toLowerCase()
                  
                      if (fa < fb) {
                        return -1
                      }
                      if (fa > fb) {
                        return 1 
                      }
                      return 0
                      
                      // Sort by date
                    } else if (this.sortBy == 'date') {
                       return b.created_at - a.created_at;
                      //return new Date(a.created_at) - new Date(b.created_at);
                    } else if (this.sortBy == 'size') {
                      var a = (a.size ? a.size : 0);
                      var b = (b.size ? b.size : 0);
                      return a - b;
                    }
                })
                
                // Show sorted array in descending or ascending order
                if (!this.ascending || this.ascending == 'false') {
                  tempItems.reverse();
                }
                
                return tempItems
          }
      },
      filters: {
          diffForHumans: (date) => {
              if (!date){
                  return null;
              }

              if(dayjs(date,'YYYY-MM-DD HH:hh:ss').isValid()){
                  return dayjs(date).fromNow();
              } else {
                  return dayjs.unix(date).fromNow();
              }
              
             
          },
          humanFileSize: (bytes) => {
              var thresh = 1024;
              if(Math.abs(bytes) < thresh) {
                  return bytes + ' B';
              }
              var units = ['KB','MB','GB','TB','PB','EB','ZB','YB'];
              var u = -1;
              do {
                  bytes /= thresh;
                  ++u;
              } while(Math.abs(bytes) >= thresh && u < units.length - 1);
              return bytes.toFixed(1)+' '+units[u];
          },

      },
      mounted() {
          this.list();
      },
      methods: {
        list(){
          axios.post('/api/folder/list',{folder_id : this.folder_id}).then( response=> {
              this.breadcrumbs = response.data.breadcrumbs;
              this.items = response.data.files.content;
              this.current_folder = { name: response.data.files.name, parent_id : response.data.files.parent_id} ;
          }).catch(error=>{
              flash(JSON.parse(error.request.response).message, 'error');
          });
        },
        getParameterFromUrl: function(param){
            var result = null,
              tmp = [];
            var items = location.search.substr(1).split("&");
            for (var index = 0; index < items.length; index++) {
              tmp = items[index].split("=");
              if (tmp[0] === param) result = decodeURIComponent(tmp[1]);
            }
            return result
        },
        selectAll: function() {
            this.allSelected = !this.allSelected; 

            this.items_selected = [];               
            if (this.allSelected) {
                for(var i = 0; i < this.items.length; i++) {
                    this.items_selected.push(this.items[i]);
                }

            }
           
        },
        select: function() {
            this.allSelected = false;
        },
        diveUpToFolder(id) {
          if(id == null){
            window.history.pushState({}, document.title, "/hdd");
            this.handleRefresh();
          } else {
             window.history.pushState({}, document.title, "/hdd?folder_id=" + id);
            this.handleRefresh();
          }
        },
        handleRefresh(){
          this.items = {};
          this.breadcrumbs = {};
          this.folder_id = this.getParameterFromUrl('folder_id');
          this.list();
        },
        exportAll(e){
          this.export_links = [];
          for(var i = 0; i < this.items.length; i++) {
              if(this.items[i].type == 'file'){
                this.export_links.push(this.items[i].link);
              }
          }
          $('#exportLinksModal').modal('toggle');
        },
        exportSelected(e){
          this.export_links = [];
          for(var i = 0; i < this.items_selected.length; i++) {
              if(this.items_selected[i].type == 'file'){
                this.export_links.push(this.items_selected[i].link);
              }
          }

          $('#exportLinksModal').modal('toggle');
        },
        zipMultipleItem(e){
          this.zip_data =  { link: null, finish: false, error: null };
          //e.target.disabled = true;
          $('#zipModal').modal('toggle');
          //e.target.innerHTML = '<svg class="icon icon-cloud-download"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-cloud-download"></use></svg> GENERATING ZIP FILE';
            var foldersItems = []; 
            var filesItems = [];

            for(var i = 0; i < this.items_selected.length; i++) {
              if(this.items_selected[i].type == 'folder'){
                foldersItems.push(this.items_selected[i].id);
              }else if(this.items_selected[i].type == 'file'){
                filesItems.push(this.items_selected[i].id);
              }
            }

          axios.post('/api/zip/generate',{'file_ids': filesItems,'folder_ids': foldersItems}).then(response=>{
              e.target.disabled = false;
              if(response.data.status == 'success'){
                this.zip_data = { link: response.data.location, finish: true, error: null };
              } 

          }).catch(error=>{
              this.zip_data = { link: null, finish: true, error:  JSON.parse(error.request.response).message };
          });
        }, 
        deleteItemModal(key ,id,name, type){
            this.selected_item = {'key' : key,'id': id, 'name' : name, 'type' : type};
            $('#deleteModal').modal('toggle');
        },
        deleteItem(){

            if(this.selected_item.type == 'folder'){
                var url = '/api/folder/delete/'+this.selected_item.id;
            } else {
                var url = '/api/item/delete/'+this.selected_item.id;
            }

            $('#delete_item_btn').attr("disabled", true).html('<i class="fas fa-spinner fa-pulse"></i> Deleting').removeClass('btn-success').addClass('btn-secondary');
            axios.delete(url).then(response=>{
              $('#delete_item_btn').attr("disabled", false).html('Yes').removeClass('btn-secondary').addClass('btn-success');
              $('#deleteModal').modal('toggle');
              this.handleRefresh();
              flash(response.data.message, 'success');
            }).catch(error=>{
                $('#delete_item_btn').attr("disabled", false).html('Yes').removeClass('btn-secondary').addClass('btn-success');
                flash(JSON.parse(error.request.response).message, 'error');
            });
        },
        deleteItems(){
            $('#deleteItemsModal').modal('toggle');
            for(var i = 0; i < this.items_selected.length; i++) {
              if(this.items_selected[i].type == 'folder'){
                  var url = '/api/folder/delete/'+this.items_selected[i].id;
              } else {
                  var url = '/api/item/delete/'+this.items_selected[i].id;
              }

              axios.delete(url).then(response=>{
                  console.log(response.data.message);
              }).catch(error=>{
                  flash(JSON.parse(error.request.response).message, 'error');
              });
            }
            
            setTimeout(()=>{
              this.items_selected = [];
              flash('The items has been deleted.', 'success');
              this.handleRefresh()
            },600);
            

        },
      }
  }
</script>